// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * Meter — an instrument circle in series, lettered `PQ`.
 *
 * IEEE 315 draws an instrument as a circle with its function letters (`A`,
 * `V`, `W`); a power-quality meter has no standard letters, so `PQ` is our
 * convention and is flagged as such in the mapping doc. The lead marks on
 * either side say it sits *in* the run, which is what separates it from the
 * utility source's sine circle at the top of the drawing.
 */
export const MeterSymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    className="sld-glyph"
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="7.5" stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    <Leads top={4.5} bottom={19.5} leads={leads} />
    <text
      x="12"
      y="15"
      textAnchor="middle"
      fontSize="7.5"
      fontWeight="500"
      fontFamily="'IBM Plex Mono', monospace"
      fill="currentColor"
    >
      PQ
    </text>
  </svg>
);
